import React from 'react';
import Modal from 'react-bootstrap/Modal';
import CourseVideo from '../course-video';
import './styles.scss';

const CourseVideoModal = ({ video, visible, onClose }) => (
  <Modal
    show={visible}
    onHide={onClose}
    aria-labelledby="contained-modal-title-vcenter"
    className="course-video-modal"
    size="lg"
    centered
  >
    <CourseVideo video={video} autoPlay />
  </Modal>
);

export default CourseVideoModal;
